/**
 * CategoryDialog — Neue Kategorie anlegen / bestehende bearbeiten.
 */
import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from '../../components/ui/dialog';

export const CategoryDialog = ({
  open, onOpenChange, editingCategory, catForm, setCatForm, onSave,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm">
      <DialogHeader>
        <DialogTitle>{editingCategory ? 'Kategorie bearbeiten' : 'Neue Kategorie'}</DialogTitle>
      </DialogHeader>
      <div className="space-y-4 pt-4">
        <div className="space-y-2">
          <Label>Name</Label>
          <Input
            value={catForm.name}
            onChange={(e) => setCatForm({ ...catForm, name: e.target.value })}
            placeholder="z.B. Personal"
            data-testid="input-cat-name"
          />
        </div>
        <div className="space-y-2">
          <Label>Farbe</Label>
          <div className="flex gap-2">
            <input
              type="color"
              value={catForm.color}
              onChange={(e) => setCatForm({ ...catForm, color: e.target.value })}
              className="w-10 h-10 rounded cursor-pointer border"
            />
            <Input value={catForm.color} onChange={(e) => setCatForm({ ...catForm, color: e.target.value })} />
          </div>
        </div>
        <div className="flex justify-end gap-2 pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
          <Button onClick={onSave}>Speichern</Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
